var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CRow',[_c('CCol',{attrs:{"sm":"12"}},[_c('CreditNotesView',{attrs:{"id":_vm.id,"is_new":_vm.id > 0 ? false : true}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }